/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as FeedDefs from './defs.defs.js'

const $nsid = 'app.bsky.feed.getFeedGenerator'

export { $nsid }

/** Get information about a feed generator. Implemented by AppView. */
const main = l.query(
  $nsid,
  l.params({ feed: l.string({ format: 'at-uri' }) }),
  l.jsonPayload({
    view: l.ref<FeedDefs.GeneratorView>((() => FeedDefs.generatorView) as any),
    isOnline: l.boolean(),
    isValid: l.boolean(),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
